import { Alert, Grid, Stack } from "@mui/material";
import Divider from "@mui/material/Divider";
import { Panel } from "@poseidon/ui/components/Panel";
import config from "@poseidon/utils/config";
import React from "react";
import { useNavigate } from "react-router-dom";
import Action from "../Action/Action";
import { BoatFileManagementSection } from "./BoatFileManagementSection";
import TextField from "@mui/material/TextField";
import { getUserLabel } from "../Users/util";
import Button from "@mui/material/Button";
import {
  WithDoc,
  WithDocLoadAware,
} from "@poseidon/firebase/components/WithDoc";

export default function BoatApplication({ application }) {
  const navigate = useNavigate();
  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      {application ? (
        <React.Fragment key={application.id}>
          <Panel
            title="Application Summary"
            actions={
              <>
                {application.agreement && (
                  <Button
                    size="small"
                    onClick={() =>
                      navigate(`/agreements/${application.agreement.id}`)
                    }
                  >
                    Go to Agreement
                  </Button>
                )}
                <Button
                  size="small"
                  onClick={() => navigate(`/applications/${application.id}`)}
                >
                  Go to Application
                </Button>
              </>
            }
          >
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Application Number"
                  margin="none"
                  sx={{ width: 1 }}
                  value={application?.applicationNumber ?? "Unknown"}
                />
              </Grid>
              {application.agreement && (
                <Grid item xs={12} sm={6}>
                  <WithDocLoadAware
                    docRef={application.agreement}
                    Component={({ data, loading }) => (
                      <TextField
                        label="Agreement Number"
                        margin="none"
                        sx={{ width: 1 }}
                        disabled={loading}
                        value={loading ? "" : data.agreementNumber}
                      />
                    )}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <WithDoc
                  docRef={application?.applicants[0]}
                  Component={({ data }) => (
                    <TextField
                      label="Sailor"
                      margin="none"
                      sx={{ width: 1 }}
                      value={getUserLabel(data)}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Panel>
          <Panel title="Boat Documentation">
            <BoatFileManagementSection
              application={application}
              sx={{ mt: 0 }}
            />
            <Divider sx={{ my: 3 }} />
            <Action
              entity={config.SaltCollection.Application}
              entityId={application.id}
              entityKey="boatDocumentation"
              application={application}
            />
          </Panel>
        </React.Fragment>
      ) : (
        <Alert severity="warning">Boat not assigned to application</Alert>
      )}
    </Stack>
  );
}
